import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErr, fetchAuth } from "../../../store/authSlice";
import { getDashboardPath } from "../../../utils/authRedirect";
import { usePortal } from "../../../context/PortalContext";
import { PORTALS } from "../../../utils/portalTypes";
import AuthLoginFlow from "../Auth/AuthLoginFlow";
import AuthPatientTabs from "../Auth/AuthPatientTabs";
import { PORTAL_PERKS } from "../Auth/portalAuthCopy";
import a from "../Auth/auth.module.css";
import Seo from "../../Seo";
import L from "../../../constants/baysportLabels";

const portal = PORTALS.patient;

export default function PatientLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subdomain, clinic } = usePortal();
  const { err, isAuth, role, load } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuth && role) {
      navigate(getDashboardPath(role), { replace: true });
    }
  }, [isAuth, role, navigate]);

  const submit = ({ login, password }) => {
    dispatch(clearErr());
    dispatch(fetchAuth({ subdomain, login, password }));
  };

  const errorText =
    typeof err === "string" ? err : err?.message || err?.error || null;

  return (
    <>
      <Seo noindex title={`Вход — ${L.portalClient}`} />
      <AuthLoginFlow
        segment={<AuthPatientTabs mode="login" />}
        heroBadge={clinic?.name}
        perks={PORTAL_PERKS.patient}
        portalId="patient"
        backTo={portal.home}
        backLabel="Назад"
        title="Вход"
        emailPlaceholder="email@example.com"
        loading={load}
        error={errorText}
        onSubmit={submit}
        footer={
          <div className={a.footerLinksModern}>
            <Link to="/forgot-password">Забыли пароль?</Link>
            <Link to={portal.register}>Нет аккаунта? Зарегистрироваться</Link>
          </div>
        }
      />
    </>
  );
}
